<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte/internal'
    import Fa from 'svelte-fa'
    import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Popover from '../../_common/popover.svelte'
    import Zoption from '../../_common/z/zoption.svelte'
    import { convertV1ToV2 } from './convert-v1-to-v2'

    const dispatch = createEventDispatcher()

    let show = true
    let error = ''
    let templates: any[] = []
    let importing = false
    let importError = ''

    onMount(load)

    async function load() {
        try {
            show = true
            templates = await window.api.tools.forms.formTemplates.getAll()
            templates = templates.filter((t: any) => t.status > 0)
        } catch {
            error = 'Não foi possível carregar os formulários v1.'
        } finally {
            show = false
        }
    }

    async function importTemplate(template: any) {
        importing = true
        importError = ''
        try {
            const full = await window.api.tools.forms.formTemplates.getOne(template.formTemplateId)
            const converted = convertV1ToV2(full)
            dispatch('import', converted)
        } catch {
            importError = 'Não foi possível importar o formulário selecionado.'
        } finally {
            importing = false
        }
    }
</script>

<!-- o Popover do app desenha a cortina, o título e o "x"; cada formulário é um Zoption, a mesma
     linha de resultado usada nas listas do ZentitySelect -->
<Popover title="Importar formulário do v1" width="560px" height="420px" padding="16px" on:close={() => dispatch('close')}>
    <p class="v1-hint">
        Escolha um formulário para importar. O conteúdo será carregado no editor sem ser salvo automaticamente — você poderá fazer ajustes antes de salvar.
    </p>

    {#if importError}
        <div class="v1-erro">
            <Fa icon={faTriangleExclamation} />
            <span>{importError}</span>
        </div>
    {/if}

    {#if error}
        <div class="v1-vazio">{error}</div>
    {:else if !show && templates.length === 0}
        <div class="v1-vazio">Nenhum formulário v1 encontrado.</div>
    {:else}
        {#each templates as t (t.formTemplateId)}
            <Zoption title={t.title} details={t.type ? [t.type] : []} disabled={importing} on:click={() => importTemplate(t)} />
        {/each}
    {/if}

    <LoadSpinner show={show || importing} />
</Popover>

<style>
    .v1-hint {
        margin: 0px 0px 12px 0px;
        font-size: 13px;
        line-height: 1.4;
        opacity: 0.75;
    }

    .v1-erro {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        padding: 10px 12px;
        border-radius: var(--z-field-radius);
        border: 1px solid #d0483e;
        background-color: #d0483e26;
        font-size: 13px;
    }

    .v1-vazio {
        padding: 24px 0px;
        text-align: center;
        font-size: 13px;
        opacity: 0.7;
    }
</style>
